// The user's background exports (files built by the Celery worker). Any signed-in
// user can export, so the page has no feature gate.
export const DOWNLOADS_ROUTES = [
  {
    path: '/downloads',
    name: 'Downloads',
    component: () => import('@/components/Downloads/DownloadsPage.vue'),
    meta: { requiresAuth: true, layout: 'default' },
  },
];

export function downloadsLocation() {
  return { name: 'Downloads' };
}
